import { getChatDashboardSettingsInitial } from '../constants';
import { IChatDashboardSettings } from '../types';
import { AT_UPDATE, TChatDashboardSettingsAction } from '../actions/types';

const initialState: IChatDashboardSettings = getChatDashboardSettingsInitial();

export const chatDashboardSettingsReducer = (
    state = initialState,
    action: TChatDashboardSettingsAction
): IChatDashboardSettings => {
    switch (action.type) {
        case AT_UPDATE: {
            return {
                ...state,
                ...action.chatDashboardSettings
            };
        }

        default:
            return state;
    }
};
